// make mobile browsers detect clicks faster
FastClick.attach(document.body);
$(document.body).on("loaded.bs.select", function(e){
  var selectpicker = $(e.target).data("selectpicker");
  selectpicker.$button.add(selectpicker.$button.find("*"))
    .addClass("needsclick");
});

/**
 * Runs on page load
 */
$(function(){
  // Microsoft added iPhone to IE11's UA...
  if (/iP(ad|hone|od)/.test(navigator.userAgent) && !window.MSStream) {
    $(document.body).addClass("iOS");
  }

  var activeIdentifier = null;
    var $active = null;
    var $openers = $(".navbar__nav > li:not(.navbar__login-buttons), .navbar__mobile-entry, .language-open-li");
    var $activeOpener = null;
    var openedByHover = false;
    var lastMousePos = null;
    var corners = null; // corners of the subnav that we are measuring towards - first index is negative slope, second is positive slope

    function disableActive() {
      activeIdentifier = null;
      $active.removeClass("active");
      $active = null;
      $activeOpener.removeClass("active");
      $activeOpener = null;
      openedByHover = false;
      lastMousePos = null;
      corners = null;
    }
  
    function setActive($li) {
      var identifier = $li.attr("data-identifier");
      var $lis = $("[data-identifier='"+identifier+"']");
      var $menu = $lis.children(".navbar__menu, .navbar__mobile-menu");
      activeIdentifier = identifier;
      $active = $menu.addClass("active");
      $activeOpener = $lis.addClass("active");
    }
  
    function slope(a,b) {
      return (b.y - a.y) / (b.x - a.x);
    }

    // toggle subnavs on hover
    $("> a", $openers).mouseenter(function(e) {
      if ($active) {
        return;
      }
      var $li = $(this).parent();
      setActive($li);
      openedByHover = true;
      // setup stuff for detecting mouse direction relative to menu
      lastMousePos = { x: e.clientX, y: e.clientY };
      if ($active.length) {
        var offset = $active.offset();
        corners = [
          { x: offset.left, y: offset.top },
          { x: offset.left + $active[0].offsetWidth, y: offset.top }
        ];
      }
    });

    // close subnavs when hovering away from them - see Amazon's mega menu for more info
    $(document.body).mousemove(function(e){
      if (!$active || !openedByHover) {
        return;
      }
      var isInActive = !!$(e.target).closest($activeOpener).length;
      var mousePos = { x: e.clientX, y: e.clientY };
      if (isInActive) {
        lastMousePos = mousePos;
        return;
      }

      var delta = Math.max(Math.abs(lastMousePos.x - mousePos.x), Math.abs(lastMousePos.y - mousePos.y));
      if (delta < 8) { return; }

      if (!corners) {
        disableActive();
        return;
      }
      
      var prevDecreasing = slope(lastMousePos, corners[0]),
          decreasing = slope(mousePos, corners[0]),
          prevIncreasing = slope(lastMousePos, corners[1]),
          increasing = slope(mousePos, corners[1]);
      
      lastMousePos = mousePos;

      // if we are moving away from the menu
      if (decreasing < prevDecreasing || increasing > prevIncreasing) {
        disableActive();
      }
    });

    // toggling subnavs on click
    $("> a", $openers).click(function(e){
      var $li = $(this).parent();
      var identifier = $li.attr("data-identifier");
      var shouldOpen = (identifier !== activeIdentifier) || openedByHover;
      if ($active) {
        disableActive();
      }
      if (shouldOpen) {
        setActive($li);
        openedByHover = false;
      }
      if ($active && $active.length) {
        e.preventDefault();
      }
    });

    // close subnavs on outside click
    $(document.body).click(function(e){
      if (!$active) { return; }
      var $target = $(e.target);
      var isInActive = !!$target.closest($openers).length;
      if (isInActive) { return; }
      var isInMobile = !!$target.closest(".navbar__mobile").length;
      if (isInMobile) { return; }
      disableActive();
      closeMobile();
    });

    // mobile sidebar
    function closeMobile() {
      $(".navbar__mobile").removeClass("active");
      $(document.body).removeClass("body--has-sidebar");
    }
    $(".navbar__mobile-close-btn").click(function(){
      closeMobile();
    });
    $(".navbar__mobile-toggle").click(function(){
      $(".navbar__mobile").toggleClass("active");
      $(document.body).toggleClass("body--has-sidebar");
    });

    $('.close-location-popup').click(function() {
      $('.language-header-section-container').hide();
      PD.utils.cookies.set('loc_redirect_optout', true);
    });
});

// click
document.addEventListener("click", function(e){
  var $elm = $(e.target);

  // checkbox
  if ($elm.parent().is(".cm-checkbox")) {
    $elm = $elm.parent();
  }
  if ($elm.is(".cm-checkbox") && !$elm.hasClass("disabled")) {
    $elm.toggleClass("checked");
    $elm.trigger("change");
  }

  // links
  if ($elm.is("a") && $elm.attr("href") === "#") {
    e.preventDefault();
  }
});

function changeLocation(short, url) {
  if (short.length > 0) {
    PD.utils.cookies.set("LOCATION", short, 365);
  }
  window.location = "https://"+url;
}

function set_language(lang) {
  // Set cookie
  PD.utils.cookies.set('language', lang, 365);
  // Refresh page
  location.reload();
}
